'use client'

import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { usePageBreadcrumb } from '@/hooks/business/pages/usePageBreadcrumb'

interface IPageBreadcrumbProps {
    slug: string
    variant?: 'default' | 'light'
}

/** Trilha da página do CMS: home, ajuda e a cadeia de categorias até a página. */
const PageBreadcrumb: React.FC<IPageBreadcrumbProps> = ({ slug, variant = 'default' }) => {
    const trail = usePageBreadcrumb(slug)
    const items = [
        { name: 'home', href: '/' },
        { name: 'ajuda', href: '/ajuda' },
        ...trail.map((p) => ({ name: p.name, href: `/p/${p.slug}` })),
    ]

    const linkClass =
        variant === 'light' ? 'text-white/90 hover:text-white underline' : 'text-secondary hover:text-primary underline'
    const sepClass =
        variant === 'light'
            ? 'text-white/70 max-w-[9px] max-md:max-w-[7px] mx-1.5'
            : 'text-darkgray max-w-[9px] max-md:max-w-[7px] mx-1.5'

    return (
        <div className="max-w-full overflow-x-auto py-2 font-bold text-[12px] max-lg:text-sm mb-4 flex w-full flex-wrap ml-4 md:ml-8">
            {/* Home, ajuda e uma página por nível da trilha: o endereço não se repete. */}
            {items.map((item, index) => (
                <div key={item.href} className="flex items-center">
                    <Link href={item.href} className={linkClass}>
                        {item.name.toLowerCase()}
                    </Link>
                    {index < items.length - 1 && <FontAwesomeIcon icon={faAngleRight} className={sepClass} />}
                </div>
            ))}
        </div>
    )
}

export default PageBreadcrumb
